import type { TabType } from '@mynt/components/Tabs'
import { useState } from 'react'

export const useActiveTabKey = (tabSetName: string, tabs: TabType[], defaultTabKey: string): [string, (activeTab: string) => void] => {
  const storedTabsSetValue = window.localStorage.getItem(tabSetName)
  const [tabKey, setTabKey] = useState<string>(getDefaultTabKey(tabs, storedTabsSetValue || defaultTabKey))

  const handleChangeTabKey = (tab: string) => {
    window.localStorage.setItem(tabSetName.toString(), tab)
    setTabKey(tab)
  }

  return [tabKey, handleChangeTabKey]
}

const getDefaultTabKey = (tabs: TabType[], key: string): string => {
  const numberKey = parseInt(key)

  // If a key has a onClick event we dont want to default to it since it can cause infinite redirect loop
  if (!Number.isNaN(numberKey)) {
    if (tabs?.[numberKey]?.onClick) {
      return '0'
    }
  }

  return key
}

export default useActiveTabKey
